module.exports = __webpack_public_path__ + "img/collect.06e31b8d.svg";